import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import Window from '../../../types/Window';
import WindowDataProcessingUtils from 'pages/utils/WindowDataProcessingUtils';

const borderColor = '#90e5fc';
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        flexGrow: 1,
        fontSize: '10px',
    },
    rate: {
        width: '7.2%',
        borderRightWidth: 1,
        borderRightColor: borderColor,
    },
    inputStyle: {
        width: '7.2%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        backgroundColor: '#ff6a6a',
        height: '100%',
        padding: '1px',
        marginTop: 1,
        paddingTop: 2,
    },
});

const TableRow: React.FC<{ items: Array<Window> }> = ({ items }) => {
    const rows = items.map((item) => (
        <View style={styles.row} key={item.id}>
            <Text style={styles.rate}>{item.id}</Text>
            <Text style={styles.rate}>{item.location}</Text>
            <Text style={styles.inputStyle}>
                {WindowDataProcessingUtils.convertingNumberToFraction(
                    item.width,
                )}
            </Text>
            <Text style={styles.rate}>
                {WindowDataProcessingUtils.convertingNumberToFraction(
                    item.widthCut,
                )}
            </Text>
            <Text style={styles.rate}>
                {WindowDataProcessingUtils.convertingNumberToFraction(
                    item.widthFit,
                )}
            </Text>
            <Text style={styles.rate}>
                {WindowDataProcessingUtils.convertingNumberToFraction(
                    item.widthInFrame,
                )}
            </Text>
            <Text style={styles.inputStyle}>
                {WindowDataProcessingUtils.convertingNumberToFraction(
                    item.height,
                )}
            </Text>
            <Text style={styles.rate}>
                {WindowDataProcessingUtils.convertingNumberToFraction(
                    item.heightCut,
                )}
            </Text>
            <Text style={styles.rate}>
                {WindowDataProcessingUtils.convertingNumberToFraction(
                    item.heightFit,
                )}
            </Text>
            <Text style={styles.rate}>
                {WindowDataProcessingUtils.convertingNumberToFraction(
                    item.heightInFrame,
                )}
            </Text>
            <Text style={styles.inputStyle}>{item.frameKind}</Text>
            <Text style={styles.inputStyle}>{item.panelDesign.name}</Text>
            <Text style={styles.inputStyle}>{item.special}</Text>
            <Text style={styles.rate}>{item.sqMaterial}</Text>
        </View>
    ));
    return <Fragment>{rows}</Fragment>;
};

export default TableRow;
